import { FormFieldResponseDTO } from '@/api/base/DTOs';
import { IFormBase, IFormRadioGroup } from '@/forms/typings';
import { RadioGroupFormFieldBuilder } from '@/forms/builders';
import { adaptFormFieldResponseToValue } from '../utilities/formFieldResponseToValue.adapter';
import { adaptInternalLookupResponseToOptions } from '../utilities/internalLookupResponseToOptions.adapter';
import { formApiAdapterRegistry } from '../registry/form-api-adapter.registry';

/**
 * Adapts a FormFieldResponseDTO to a RadioGroupFormField
 * Handles fields with internal lookups configured as radio buttons
 */
export const adaptFormFieldResponseToRadioGroupFormField = (
  formFieldResponse: FormFieldResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): IFormRadioGroup => {
  let radioGroupFormField = new RadioGroupFormFieldBuilder()
    .fieldId(formFieldResponse.fieldID)
    .name(formFieldResponse.fieldID)
    .label(formFieldResponse.label ?? formFieldResponse.name)
    .readonly(formFieldResponse.readonly || !formFieldResponse.isEditable)
    .value(adaptFormFieldResponseToValue(formFieldResponse))
    .hasAnyValue(formFieldResponse.hasAnyValue)
    .notApplicable(formFieldResponse.notApplicable)
    .showNotApplicable(formFieldResponse.showNotApplicable)
    .size(formFieldResponse.itemSize)
    .useShortName(formFieldResponse.internalLookup?.useShortName ?? false)
    .options(
      formFieldResponse.internalLookup
        ? adaptInternalLookupResponseToOptions(
            formFieldResponse.internalLookup,
            formFieldResponse.values,
          )
        : undefined,
    );

  if (formFieldResponse.hint) {
    radioGroupFormField = radioGroupFormField.hint(formFieldResponse.hint);
  }

  if (formFieldResponse.hintImageUrl) {
    radioGroupFormField = radioGroupFormField.hintImageUrl(
      formFieldResponse.hintImageUrl,
    );
  }

  const radioGroupFieldValidations =
    formApiAdapterRegistry.adaptGeneric(
      formFieldResponse.restriction,
    ) as IFormRadioGroup['validations'];

  if (radioGroupFieldValidations) {
    radioGroupFormField = radioGroupFormField.validations(
      radioGroupFieldValidations,
    );
  }

  return radioGroupFormField.parentFieldId(parentFieldId).build();
};
